<div class="containeer-fluid">
    <div class="row">
      <div class="col-md-12 mt-3">
        <div class="row">
         
          <div class="col-md-12">
              <p>
                  <form-error [form]="form"></form-error>
              </p>
              <a
            (click)="gotoLogin()"
              type="button"           
              class="btn btn-primary btn-sm"
              title="Login"
            >
              <i class="fas fa-save"></i> Login
            </a>
        
          </div>
        </div>
      </div>
    </div>
  </div>
  